import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const MortgagePayment = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { interest, taxes, mortgageInsurance, hazardInsurance, mortgagePayment } = props;

  return (
    <Box className={classes.paper}>
      <Typography variant="body1" color="inherit" className={classes.label}>
        {t('components.Quiz.SummaryPage.MortgagePayment.label')}
      </Typography>
      <Box my={2}>
        <Typography variant="h1">
          <NumberFormat value={mortgagePayment} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
        </Typography>
      </Box>
      <Typography color="secondary" variant="body2">
        {t('components.Quiz.SummaryPage.MortgagePayment.breakdown')}
      </Typography>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={interest} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MortgagePayment.principal')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={taxes} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MortgagePayment.taxes')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={mortgageInsurance} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MortgagePayment.mortgageInsurance')}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={hazardInsurance} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MortgagePayment.hazardInsurance')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

MortgagePayment.propTypes = {
  interest: PropTypes.number.isRequired,
  taxes: PropTypes.number.isRequired,
  mortgageInsurance: PropTypes.number.isRequired,
  hazardInsurance: PropTypes.number.isRequired,
};

export default MortgagePayment;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MortgagePayment/MortgagePayment.js